export const validateEmail = (email) => {
  if (!email) return 'Email is required';
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase()) ? null : 'Invalid email format';
};

export const validateMobile = (mobile) => {
  if (!mobile) return 'Mobile number is required';
  const re = /^(?:\+27|0)[6-8][0-9]{8}$/;
  return re.test(mobile) ? null : 'Invalid South African mobile number';
};

export const validateRequired = (value, fieldName = 'This field') => {
  return value && String(value).trim().length > 0 ? null : `${fieldName} is required`;
};

export const validateMinLength = (value, min, fieldName) => {
  if (!value || String(value).length < min) {
    return `${fieldName} must be at least ${min} characters`;
  }
  return null;
};

export const validatePassword = (password) => {
  if (!password) return 'Password is required';
  if (password.length < 8) return 'Password must be at least 8 characters';
  if (!/[A-Z]/.test(password)) return 'Password must contain an uppercase letter';
  if (!/[a-z]/.test(password)) return 'Password must contain a lowercase letter';
  if (!/[0-9]/.test(password)) return 'Password must contain a number';
  return null;
};

export const validateIdNumber = (id) => {
  if (!id) return 'ID number is required';
  const re = /^[0-9]{13}$/;
  // Further SA ID validation (Luhn algorithm etc.) could be added here
  return re.test(id) ? null : 'Invalid 13-digit SA ID number';
};
